import i18next from 'i18next';
import da from '@/i18n/da.json';
import en from '@/i18n/en.json';
import { LanguageTypes, LANGUAGE } from '@/constants/system';

// The tenant's default language comes from the runtime config and is applied in
// the entry bootstrap (index.tsx) once the config bag loads — i18next.init runs
// at module-load, before the config fetch. Here we only honor a language the
// user explicitly chose (localStorage), falling back to Danish.
const initLanguage = () => {
  const languageStorage = localStorage.getItem(LANGUAGE);
  let currentLanguage =
    languageStorage || LanguageTypes.da || window.navigator.language;
  const languageList = Object.keys(LanguageTypes);

  if (languageList?.indexOf(currentLanguage) === -1) {
    currentLanguage = LanguageTypes.da;
  }
  return currentLanguage;
};

i18next.init({
  interpolation: {
    escapeValue: false,
  },
  lng: initLanguage(),
  resources: {
    en: {
      translation: en,
    },
    da: {
      translation: da,
    },
  },
});

export default i18next;
